// src/services/joinFloor.js — a member added to a group starts at the moment they joined (the phone's
// services/joinFloor.ts, the browser's half).
//
// 🟥 A new member's browser asked for the group's newest messages like everyone else's — all of them
//    from before they joined, sealed for the members of the time — and showed a 🔒 for each, in the
//    chat and as the list's preview. 🟢 WhatsApp's rule: nothing before the join is asked for.

export const msOf = (v) => {
  if (v == null) return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  if (v instanceof Date) return v.getTime();
  if (typeof v.toMillis === 'function') { try { return v.toMillis(); } catch { return 0; } }
  if (typeof v.toDate === 'function') { try { return v.toDate().getTime(); } catch { return 0; } }
  if (typeof v.seconds === 'number') return v.seconds * 1000;
  const p = Date.parse(String(v));
  return Number.isFinite(p) ? p : 0;
};

/** When I joined this group (ms); 0 for a 1:1, a group I created, or no record. */
export function joinedMsOf(chat, me) {
  if (!chat || !me || chat.isGroup !== true) return 0;
  return msOf((chat.joinedAt || {})[me]);
}

/** What the cloud may be asked for: only after the later of my clear and my join. */
export function fetchFloorMs(joinedMs, clearedMs = 0) {
  const j = joinedMs > 0 ? joinedMs - 1 : 0;
  return Math.max(Number(clearedMs) || 0, j);
}
